import { render } from "./AuthorCard.vue?vue&type=template&id=d934bba4"
import script from "./AuthorCard.vue?vue&type=script&lang=js"
export * from "./AuthorCard.vue?vue&type=script&lang=js"
script.render = render

export default script